module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page_border"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bf04494!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/index.vue
// module id = 195
// module chunks = 0